angular.module('impactx.productlabel').controller('ProductLabelInfoTextDialogCtrl', [
    'dataGen',
    '$mdDialog',
    ProductLabelInfoTextDialogController
]);

function ProductLabelInfoTextDialogController(dataGen, $mdDialog) {
    var self = this;

    dataGen.getData(self, {productLabelId: self.productLabelId}, '/productlabel/infotext');

    self.close = function () {
        $mdDialog.hide();
    };
}